/* global google */
import moment from 'moment'
import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import withStore from 'with/Store'

import Checkbox from 'components/Checkbox'
import Paper from 'components/Paper'
import Center from 'layout/Center'
import Button from 'components/buttons/Button'

import Modal from 'components/Modal'
import FormWithActions from 'layout/FormWithActions'

import styles from './index.css'

import { LoadingBox } from 'components/LoadingSpinner'

import handleFormErrors from 'utils/handleFormErrors'

import $tracker from 'utils/trackerService'

import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { logout } from 'utils/auth';

const { GMAPS_API_KEY } = process.env;

const MyMapComponent = withScriptjs(withGoogleMap(({lat, lng, ...props}) =>
  <GoogleMap
    defaultZoom   = {16}
    defaultCenter = {{ lat, lng }}
    center        = {{ lat, lng }}
  >
    {props.isMarkerShown && <Marker position={{ lat, lng }} />}
  </GoogleMap>
))

@withRouter
@withStore()
export default class Tracker extends React.Component {
  
  static propTypes = {
  }

  state = {
    user : { name: 'Joe Black' },
    
    session: null,

    clock_on: false,

    truck_overnight: false,
    washing: false,
    break: false,
    
    hours: '00',
    minutes: '00',
    seconds: '00',

    lat: 0, lng: 0,
  }

  constructor(props) {
    super(props)
    this.updateTime    = this.updateTime.bind(this)
    this.doClockIn     = this.doClockIn.bind(this)
    this.doClockOut    = this.doClockOut.bind(this)
    this.startTracking = this.startTracking.bind(this)
    this.stopTracking  = this.stopTracking.bind(this)
  }

  updateTime() {
    let {start_time} = this.state.session 
    
    var diff = moment().unix() - moment(start_time).unix()
    var counter = moment.utc(diff*1000)
    this.setState({
      hours   : counter.format('HH'),
      minutes : counter.format('mm'),
      seconds : counter.format('ss')
    })
  }

  startClocking() {
    this.updateTime()
    this.counter = setInterval(this.updateTime, 1000)
  }

  stopClocking() {
    clearInterval(this.counter)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState) {
      if (!prevState.clock_on && this.state.clock_on) {
        this.startClocking()
      }
      if (prevState.clock_on && !this.state.clock_on) {
        this.stopClocking()
      }
    }
  }

  async queryPosition() {
    //return { latitude: -1, longitude: -1 }
    return new Promise((resolve, reject) => {
      var options = {
        //enableHighAccuracy: false,
        //timeout: 15000,
        //maximumAge: 5 * 60 * 1000 // five minutes
        //maximumAge: Infinity,
        timeout   : 60000,
        watch     : false,
      };
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        resolve(coords)
      }, err => {
        console.log("GEOLOCATION ERROR:", err)
        if (err.code == 1) {
          this.props.dispatch({ type: 'SHOW_ERROR', payload: "Location permission is required to continue" })
        } else {
          this.props.dispatch({ type: 'SHOW_ERROR', payload: err.message })
        }

        resolve(null)
      }, options)
    })
  }

  startTracking() {
    this.watchId = navigator.geolocation.watchPosition(pos => {
      console.log("LAT:", pos.coords.latitude, "LNG:", pos.coords.longitude)
      this.setState({ lat: pos.coords.latitude, lng: pos.coords.longitude })
    }, err => {
      switch (err.code) {
        case err.PERMISSION_DENIED:
            this.props.dispatch({ type: 'SHOW_ERROR', payload: "Permission denied" })
          break;
        case err.POSITION_UNAVAILABLE:
            this.props.dispatch({ type: 'SHOW_ERROR', payload: "Position unavailable" })
          break;
        case err.TIMEOUT: 
            this.props.dispatch({ type: 'SHOW_ERROR', payload: "Timed out" })
          break;
      }
    },
    { timeout: 60000 })
  }

  stopTracking() {
    navigator.geolocation.clearWatch(this.watchId);
  }

  async doClockIn() {
    if (this.state.clocking) return false

    this.setState({ clocking: true })
    let coords = await this.queryPosition() || { latitude: -1, longitude: -1 }
    this.setState(
      $tracker.turnClockOn(
        (new Date()).toISOString(), 
        coords.latitude, 
        coords.longitude
      ) 
    )
    this.setState({ 
      lat: coords.latitude,
      lng: coords.longitude,
      clocking: false 
    })
  }

  async doClockOut() {
    if (this.state.clocking || !this.state.session) return false
    
    this.setState({ clocking: true })
    
    let coords = await this.queryPosition() || { latitude: -1, longitude: -1 }
    
    this.setState(
      $tracker.turnClockOff(
        (new Date()).toISOString(), 
        coords.latitude, 
        coords.longitude,
        this.state.session.break
      ) 
    )
    this.setState({ 
      lat: coords.latitude,
      lng: coords.longitude,
      clocking: false 
    })
    this.setState({
      hours   : '00',
      minutes : '00',
      seconds : '00',
    })
  }

  async componentDidMount() {

    // redirect to enter code if user is not logged in
  /*  let user = window.localStorage.getItem('employee')
    if (!user) {
      return this.props.history.push('/enterCode')
    }
  */

    this.setState({ loading: true })
    const initialState = $tracker.init()
    this.setState({ 
      user: JSON.parse(window.localStorage.getItem('employee') || '{}'),
      ...initialState
    })

    const coords = await this.queryPosition()
    if (!coords) {
      return this.props.history.push('/enterCode')
    } else {
      this.setState({ lat: coords.latitude, lng: coords.longitude })
    }

    // get active tracking data
    const activeState = await $tracker.getActiveEntry()

    this.setState({ 
      clock_on: activeState.session != null,
      ...activeState,
    })
    this.setState({ loading: false })

    this.startTracking()
  }

  componentWillUnmount() {
    clearInterval(this.counter)
    this.stopTracking()
  }

  render() {
    if (this.state.loading) 
      return <Center><LoadingBox /></Center>

    return [
      <Modal key={1} open={this.state.confirmingClockOut}>
        <FormWithActions 
          title={"Clocking Out"}
          actions={[
            <Button key={1} color='grey' onClick={() => this.setState({ confirmingClockOut: false })}>Cancel</Button>,
            <Button key={2} color='orange' onClick={() => {
                this.setState({ confirmingClockOut: false })
                this.doClockOut()
              }}>
              I'm sure
            </Button>
          ]}>
          <div className={styles.ClockOutDialogText}>
            Are you sure to clock out <br/>
            <blockquote>
              {this.state.session && this.state.session.break    ? ` with ${this.state.session.break} min break`    : ' without break'},<br/>
              {/*{this.state.washing         ? ' with washing'         : ' without washing'},<br/>*/}
              {this.state.truck_overnight ? ' with truck overnight ': ' without truck overnight '}<br/>
            </blockquote>
            and duration {this.state.hours}:{this.state.minutes}:{this.state.seconds}?
          </div>
        </FormWithActions>
      </Modal>
      ,
      <Center key={2}>
        {
          <Paper>
            <div className={styles.Tracker}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h1>{this.state.user.name}</h1>
                <div 
                  className={styles.Logout} 
                  onClick={() => {
                    logout();
                    this.props.history.replace('/enterCode')
                  }}>
                  Logout
                </div>
              </div>
              <hr/>
              <MyMapComponent 
                isMarkerShown 
                lat              = {this.state.lat}
                lng              = {this.state.lng}
                googleMapURL     = {`https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                loadingElement   = {<div style={{ height: `100%` }} />}
                containerElement = {<div style={{ width: '300px', height: '300px'  }} />}
                mapElement       = {<div style={{ width: '300px', height: '300px' }} />}
                />
                <hr/>
              <div align='center'>
                <h2 className={styles.Date}>{moment().format('dddd Do MMMM')}</h2>
                <div className={styles.CounterDisplay}>
                  <div>
                    <h1>{this.state.hours}:{this.state.minutes}:{this.state.seconds}</h1>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-around'}}>
                    <h2>Hrs</h2>
                    <h2>Min</h2>
                    <h2>Sec</h2>
                  </div>
                </div>
                <br/><br/>
                { 
                  this.state.session &&
                    <div className={styles.Controls}>
                      <hr/>
                      <br/><br/>
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <h2>Add break</h2>
                        <select
                          className={styles.BreakSelect}
                          onChange={(e) => this.setState($tracker.setBreak(parseInt(e.target.value)))}
                          >
                          <option value={0} selected={this.state.session.break == 0 ? true : false}>0:00</option>
                          <option value={30} selected={this.state.session.break == 30 ? true : false}>0:30</option>
                          <option value={60} selected={this.state.session.break == 60 ? true : false}>1:00</option>
                          <option value={90} selected={this.state.session.break == 90 ? true : false}>1:30</option>
                          <option value={120} selected={this.state.session.break == 120 ? true : false}>2:00</option>
                        </select>
                      </div>
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <h2>Truck Overnight</h2>
                        <Checkbox 
                          value={this.state.truck_overnight} 
                          onChange={truck_overnight => this.setState($tracker.setTruckOvernight(truck_overnight))}
                          />
                      </div>
                      {/*
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <h2>Washing</h2>
                        <Checkbox 
                          value={this.state.washing} 
                          onChange={washing => this.setState($tracker.setWashing(washing))}
                          />
                      </div>
                      */}
                      <br/><br/>
                      <hr/>
                      <br/><br/>
                    </div>
                }
                {
                  this.state.clock_on &&
                    <Button color='grey' loading={this.state.clocking} onClick={() => this.setState({ confirmingClockOut: true })}>Clock out</Button>
                }
                {
                  !this.state.clock_on && 
                    <Button color='orange' loading={this.state.clocking} onClick={this.doClockIn}>Clock on</Button>
                }
              </div>
            </div>
          </Paper>
        }
      </Center>
    ]
  }

}



// WEBPACK FOOTER //
// ./src/pages/Tracker/index.jsx